import React, { useEffect } from 'react';
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchInvestigationTest } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useSelector } from 'react-redux';

const MultiSelectInvestigationDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
}) => {
  const selectedInvestigations = watch("investigation_ids") || [];
  const login = useSelector((state) => state.jwtAuthreducer);

  const {
    data: Investigations,
    isLoading,
    refetch,
    error,
  } = useQuery(["Investigation", selectedInvestigations],
    () => fetchInvestigationTest({ payload: { ...login } }), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  useEffect(() => {
    refetch()
  }, [login])
  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Lab Department</div>;

  const modifiedData = Investigations?.data?.data?.map((ele) => ({
    ...ele,
    investigation_id: ele.id,
  }));

  const options =
    modifiedData?.map((investigation) => ({
      value: investigation.investigation_id,
      label: investigation.investigation_name,
    })) || [];

  const selectedOptions = options.filter(option =>
    selectedInvestigations.includes(option.value)
  );

  return (
    <Controller
      name="investigation_ids"
      control={control}
      rules={{ required: "Investigation Name is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isMulti // Enable multi-select
          isClearable
          value={selectedOptions}
          placeholder="Select Investigation Name"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOptions) => {
            const values = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
            field.onChange(values);
            setValue("investigation_ids", values);

          }}
          className={`react-select-container ${errors.investigation_ids ? "is-invalid" : ""
            }`}
        />
      )}
    />
  );
};

export default MultiSelectInvestigationDropdown;
